import { apiClient } from "./ApiClient";

export const fetchUserEsims = async (params = {}) => {
  try {
    const { data } = await apiClient.get("/esim/batch/user", { params });
    return data;
  } catch (error) {
    console.error("Error fetching user eSIMs:", error);
    return { total: 0, items: [] };
  }
};

export const markEsimAsDeleted = async (iccids) => {
  try {
    const { data } = await apiClient.patch("/esim/deleted", iccids);
    return data;
  } catch (error) {
    console.error("Error marking eSIM as deleted:", error);
    throw error;
  }
};

export const markEsimAsUndeleted = async (iccids) => {
  try {
    const { data } = await apiClient.patch("/esim/undeleted", iccids);
    return data;
  } catch (error) {
    console.error("Error restoring eSIM:", error);
    throw error;
  }
};

export const fetchQrCodeSvg = async (iccid) => {
  try {
    const { data } = await apiClient.get(`/esim/qr_code/esim/${iccid}`, {
      responseType: "text",
    });
    return data;
  } catch (error) {
    console.error("Error fetching QR code:", error);
    return null;
  }
};

export const fetchInstallationInstructions = async (deviceType, installMethod, language) => {
  const manType = installMethod === "qr" ? "qr" : "manual";
  const currentLang = language || localStorage.getItem("i18nextLng") || "en";
  try {
    const { data } = await apiClient.get(`/instruction/manual/${deviceType}?language=${currentLang}&man_type=${manType}`);
    return data;
  } catch (error) {
    console.error("Instructions error:", error);
    return null;
  }
};

export const fetchDisableInstructions = async (deviceType, language) => {
  const currentLang = language || localStorage.getItem("i18nextLng") || "en";
  try {
    const { data } = await apiClient.get(`/instruction/manual/${deviceType}?language=${currentLang}&action=disable`);
    return data;
  } catch (error) {
    console.error("Disable instructions error:", error);
    return null;
  }
};

export const updateAutoTopup = async (iccid, automaticTopup) => {
  try {
    const { data } = await apiClient.put(`/esim/auto-topup/${iccid}`, {
      automatic_topup: automaticTopup,
    });
    return data;
  } catch (error) {
    console.error("Error updating auto-topup:", error);
    throw error;
  }
};

export const requestRefund = async (iccid, reason) => {
  try {
    const params = new URLSearchParams({
      iccid: iccid,
      reason: reason,
    });

    const { data } = await apiClient.post(`/esim/refund/request?${params.toString()}`);
    return data;
  } catch (error) {
    console.error("Refund request error:", error);
    throw error;
  }
};

export async function fetchEsimBatchAdmin({
  token,
  skip = 0,
  limit = 50,
  sort_by = "created_at",
  sort_order = "desc",
  filters = {},
}) {
  try {
    const params = new URLSearchParams({
      skip,
      limit,
      sort_by,
      sort_order,
      ...Object.fromEntries(Object.entries(filters).filter(([k, v]) => v !== undefined && v !== null && v !== "")),
    });

    const { data } = await apiClient.get(`/esim/batch/admin?${params.toString()}`);
    return data;
  } catch (error) {
    console.error("Refund request error:", error);
    throw error;
  }
}
